import * as React from "react"
import { MarkupComponents } from "@indeed/frontend-markup-react-components"
import { Heading, Text } from "@indeed/ifl-components"
import { useDateFormatter } from "../../common/hooks/useDateFormatter"
import { useI18n } from "../../common/utils/i18n-context"
import { useAppSelector } from "../../common/utils/redux-helpers"
import { effectiveDateSelector } from "./pause-slice"

export const PauseAlreadyPaused: React.FC = () => {
    const pauseEndDate = useAppSelector(effectiveDateSelector)
    const dateFormatter = useDateFormatter()
    const { gettext } = useI18n()

    return (
        <>
            <Heading as="h1" level={4}>
                {gettext("It looks like you already paused these communications.")}
            </Heading>
            <Text>
                <MarkupComponents
                    components={{
                        strongText: "strong",
                    }}
                >
                    {gettext("Communications will resume on [{0}|strongText].", [dateFormatter(pauseEndDate, { dateStyle: "long" })])}
                </MarkupComponents>
            </Text>
        </>
    )
}
